import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { Path, Polygon } from "react-native-svg";

function CheckboxIcon({
  size,
  color,
  selectedColor = color,
  checked,
}: {
  size: number;
  color: DripsyColor;
  selectedColor?: DripsyColor;
  checked: boolean | number;
}) {
  const selectedFinalColor = useDripsyColor({ color: selectedColor });

  return checked ? (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Polygon id="Path" points="0 0 24 0 24 24 0 24" />
      <Polygon id="Path" fill={selectedFinalColor} points="5 5 19 5 19 19 5 19" />
      <Path
        d="M19,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z M19,19 L5,19 L5,5 L19,5 L19,19 Z"
        id="Shape"
        fill={selectedFinalColor}
        fillRule="nonzero"
      />
      <Polygon
        id="Path"
        fill="#FFFFFF"
        fillRule="nonzero"
        points="17.99 9 16.58 7.58 9.99 14.17 7.41 11.6 5.99 13.01 9.99 17"
      />
    </Svg>
  ) : (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill={selectedFinalColor}>
      <Path d="M0 0h24v24H0V0z" fill="none" />
      <Path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
    </Svg>
  );
}
export default CheckboxIcon;
